import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
class Home extends Component{
    constructor(props){
        super(props);
        this.state = {
            modal: false
        }
        this.toggle = this.toggle.bind(this);
    }

    toggle() {
        this.setState(prevState => ({
          modal: !prevState.modal
        }));
    }

    handleLoad = () => {
        if(!sessionStorage.getItem('initial_pop')){
            sessionStorage.setItem('initial_pop', '1');
            this.toggle();
        }
    }

    componentDidMount(){
        window.addEventListener('load', this.handleLoad);
    }

    render(){
        return(
            <div className="home-wrapper application-container">
                <Modal id="infoModal" isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
                    <ModalHeader toggle={this.toggle}>
                        Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt
                    </ModalHeader>
                    <ModalBody>
                        <p className="modal-content">
                            Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                        </p>
                    </ModalBody>
                </Modal>
            </div>
        )
    }
}
export default Home;
